var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhatsapp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-whatsapp",
    "data-name": "Icon awesome-whatsapp",
    d: "M12.753,4.43a7.435,7.435,0,0,0-11.7,8.97L0,17.25l3.941-1.035a7.41,7.41,0,0,0,3.552.9h0A7.5,7.5,0,0,0,15,9.686,7.462,7.462,0,0,0,12.753,4.43ZM7.5,15.867a6.167,6.167,0,0,1-3.147-.86l-.224-.134-2.337.613.623-2.28-.147-.234A6.19,6.19,0,1,1,13.744,9.686,6.247,6.247,0,0,1,7.5,15.867Zm3.388-4.627c-.184-.094-1.1-.542-1.269-.6s-.295-.094-.419.094-.479.6-.589.73-.218.141-.4.047A5.056,5.056,0,0,1,5.679,9.3c-.191-.328.191-.3.546-1.015a.344.344,0,0,0-.017-.325c-.047-.094-.419-1.008-.573-1.379s-.3-.311-.419-.318-.231-.007-.355-.007a.688.688,0,0,0-.5.231,2.087,2.087,0,0,0-.65,1.55,3.639,3.639,0,0,0,.757,1.922,8.3,8.3,0,0,0,3.174,2.806,3.634,3.634,0,0,0,2.23.465,1.9,1.9,0,0,0,1.252-.884,1.553,1.553,0,0,0,.107-.884C11.193,11.377,11.069,11.33,10.885,11.24Z",
    transform: "translate(0 -2.25)",
    fill: "#666262"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.42c8f0d5f7675961c1f280c0d7c8cc39.svg";
export { ForwardRef as ReactComponent };